import { getFiles } from '@/API/repositories/file';
import { getFileById } from '@/API/repositories/storedDocument';
import ActionButton from '@/common/components/buttons/ActionButton';
import Loading from '@/common/components/Loading';
import { FILE_TYPES } from '@/common/constants/fileTypes';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { PageWrapper } from '@/common/styles/Wrappers';
import { useEffect, useState } from 'react';
import CallCenterPositionForm from './components/fileForm/FileForm';
import CallCenterPositionTable from './components/fileTable/FileTable';
import { ContentWrapper } from './File.styled';

const File = () => {
	const [show, setShow] = useState(false);
	const [selectedFile, setSelectedFile] = useState();
	const [files, setFiles] = useState([]);
	const [loadingFiles, setLoadingFiles] = useState([]);

	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const loadPages = async () => {
		setFiles([]);
		const response = await makeRequest(() => getFiles(FILE_TYPES.CC));

		if (!response?.data) {
			return addMessage('Something went wrong', 'error');
		}

		setFiles(response.data);
	};

	const handleDownloadFile = async (file) => {
		const { _id: id, extension, filename, stored_document } = file;
		setLoadingFiles((prev) => [...prev, id]);

		const response = await makeRequest(getFileById.bind(null, stored_document));

		if (response.data) {
			const url = window.URL.createObjectURL(
				new Blob([new Uint8Array(response.data.data.data).buffer]),
			);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `${filename}.${extension}`);
			document.body.appendChild(link);
			link.click();
		}

		setLoadingFiles((prev) => prev.filter((el) => el !== id));
	};

	useEffect(() => {
		loadPages();
	}, []);

	return (
		<PageWrapper>
			{hasUnfilledRequest(getFiles) && <Loading />}
			<ContentWrapper>
				<ActionButton
					defaultText='Add file'
					onClick={() => {
						setSelectedFile(null);
						setShow(true);
					}}
				/>
			</ContentWrapper>
			{show && (
				<CallCenterPositionForm
					selectedFile={selectedFile}
					reload={loadPages}
					setShow={setShow}
				/>
			)}
			{!!files?.length && (
				<CallCenterPositionTable
					loadingFiles={loadingFiles}
					handleDownloadFile={handleDownloadFile}
					setSelectedFile={setSelectedFile}
					setShow={setShow}
					files={files}
				/>
			)}
		</PageWrapper>
	);
};

export default File;
